import type { Attribute } from '@/common/attribute';
import { getAttributes } from '@/common/attribute';
import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const useAttributes = (flag: string | null, value1?: string | null) => {
  const queryClient = useQueryClient();

  const resetAttributes = () => queryClient.removeQueries({ queryKey: ['attributes'] });

  const query = useQuery<ApiResponse<{ data: Attribute[] }>>({
    queryKey: ['attributes', flag, value1],
    queryFn: () => getAttributes({ queryKey: ['attributes', flag!, value1 ?? null] }),
    enabled: !!flag,
  });

  return { ...query.data?.data, resetAttributes };
};
